import couponSetCodesBulk from "@assets/images/coupon-set-codes-bulk.svg";
import { Button } from "@material-ui/core";
import useDownloadTemplate from "@saleor/coupons/views/CouponSetCodesPage/useDownloadTemplate";
import React, { FC } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

interface ICouponBulkSetCodeProps {
  onButtonClick: () => void;
}

const CouponBulkSetCode: FC<ICouponBulkSetCodeProps> = ({ onButtonClick }) => {
  const classes = useStyles({});

  const { downloadTemplate } = useDownloadTemplate();

  return (
    <div className={classes.container}>
      <SVG src={couponSetCodesBulk} />
      <div className={classes.textContainer}>
        <span className={classes.title}>
          <FormattedMessage
            defaultMessage="Bulk Unlock Code Upload"
            description="Manual create unlock codes"
          />
        </span>
        <span>
          Download an{" "}
          <span
            id="bulk-download-template-link"
            className={classes.spanLink}
            onClick={downloadTemplate}
          >
            .xlsx
          </span>{" "}
          template file for bulk unlock code upload.
        </span>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            onClick={onButtonClick}
            style={{ backgroundColor: "#1848FE" }}
          >
            <span style={{ color: "#ffffff", fontWeight: "bold" }}>
              <FormattedMessage
                defaultMessage="use tool"
                description="button"
              />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CouponBulkSetCode;
